<template lang="html">

 <section class="intro-xs">
  <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">
    <div class="container-text">
      <h1 class="title title-52" v-html="$t('trabaja_con_nosotros.intro.titulo')"></h1>
    </div>
  </div>
</section>

</template>

<script lang="js">
  export default  {
    name: 'trabaja-con-nosotros',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped>
.trabaja-con-nosotros {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/trabaja-con-nosotros.vue